.chat {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.head {
  position: sticky;
  top: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  padding-top: calc(12px + var(--chat-inset-top, 0px));
  border-bottom: 1px solid var(--line);
  background: color-mix(in srgb, var(--bg-raised) 86%, transparent);
  backdrop-filter: blur(12px);
}

.back {
  all: unset;
  cursor: pointer;
  width: 30px;
  height: 30px;
  margin-left: -6px;
  display: grid;
  place-items: center;
  color: var(--accent);
}

.back svg {
  width: 22px;
  height: 22px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.who {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  line-height: 1.25;
}

.who b {
  font-weight: 500;
  font-size: 15.5px;
}

.who small {
  font-size: 12.5px;
  color: var(--muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.who small.live {
  color: var(--danger);
}

.av {
  flex: none;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-family: var(--font-display);
  font-style: italic;
  font-size: 13px;
  color: var(--on-fill);
  background: var(--fill);
  background-image: var(--fill-gradient);
  box-shadow: 0 0 0 1.5px var(--fill-ring);
}

.avLg {
  width: 40px;
  height: 40px;
  font-size: 19px;
}

.avPhoto {
  overflow: hidden;
  background: var(--surface);
  background-image: none;
}

.avPhoto img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avUser {
  background: var(--surface);
  background-image: none;
  color: var(--muted);
  box-shadow: inset 0 0 0 1px var(--line);
  font-family: var(--font-body);
  font-style: normal;
  font-size: 12px;
}

.st {
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  font-weight: 500;
  padding: 2px 10px;
  border-radius: 999px;
  background: var(--pill-bg);
  color: var(--muted);
  white-space: nowrap;
}

.st_new {
  color: var(--accent);
}

.st_work {
  color: var(--danger);
  background: color-mix(in srgb, var(--danger) 12%, transparent);
}

.st_ready {
  color: var(--ok);
  background: color-mix(in srgb, var(--ok) 14%, transparent);
}

.st_off {
  color: var(--muted-dim);
}

.recdot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--danger);
  display: inline-block;
  animation: pulse 1.2s infinite;
}

@keyframes pulse {
  50% {
    opacity: 0.3;
  }
}

.hero {
  align-self: stretch;
  margin: 6px 0;
  padding: 14px 14px 12px;
  border-radius: 24px;
  background: radial-gradient(120% 90% at 50% 0, var(--glow), transparent 70%), var(--surface);
  border: 1px solid var(--pill-line);
  box-shadow: 0 14px 30px color-mix(in srgb, var(--text) 8%, transparent);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.heroHead {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
}

.heroHead small {
  font-size: 12px;
  color: var(--muted-dim);
}

.eyebrow {
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--accent);
}

.heroTitle {
  font-family: var(--font-display);
  font-style: italic;
  font-size: 19px;
  line-height: 1.2;
}

.heroText {
  margin: 6px 0 0;
  font-size: 15px;
  line-height: 1.45;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.msgs {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 14px 12px;
}

.topics {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px;
  padding-bottom: 6px;
  margin-bottom: 4px;
  border-bottom: 1px solid var(--line);
}

.topic {
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.04em;
  color: var(--on-fill, var(--bg));
  padding: 4px 12px;
  border-radius: 999px;
  background: var(--accent);
}

.day {
  align-self: center;
  font-size: 11.5px;
  color: var(--muted-dim);
  padding: 2px 12px;
  border-radius: 999px;
  background: var(--pill-bg);
  margin-block: 6px;
}

.sys {
  align-self: center;
  max-width: 88%;
  text-align: center;
  font-size: 12.5px;
  color: var(--muted);
  line-height: 1.45;
  padding: 4px 8px;
}

.row {
  display: flex;
  gap: 8px;
  align-items: flex-end;
  max-width: 100%;
  animation: inmsg 0.32s cubic-bezier(0.2, 0.8, 0.3, 1) both;
}

.me {
  justify-content: flex-end;
}

@keyframes inmsg {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .row {
    animation: none;
  }
}

.bub {
  position: relative;
  max-width: min(84%, 520px);
  padding: 9px 13px 7px;
  border-radius: 18px 18px 18px 6px;
  background: var(--surface);
  border: 1px solid var(--line);
  font-size: 14.5px;
  line-height: 1.5;
  min-width: 0;
  overflow-wrap: anywhere;
}

.me .bub {
  border-radius: 18px 18px 6px 18px;
  background: color-mix(in srgb, var(--accent) 14%, var(--surface));
  border-color: color-mix(in srgb, var(--accent) 30%, transparent);
}

.bubVoice {
  width: 300px;
  max-width: 100%;
  padding: 8px 10px 6px 8px;
}

.text {
  margin: 0;
  white-space: pre-wrap;
}

.caption {
  margin: 6px 0 0;
  font-size: 14px;
  white-space: pre-wrap;
}

.hero .caption {
  margin: 0;
  color: var(--muted);
}

.meta {
  display: block;
  text-align: right;
  font-size: 11px;
  color: var(--muted-dim);
  margin-top: 2px;
  font-variant-numeric: tabular-nums;
}

.cards {
  display: flex;
  gap: 6px;
  margin-top: 6px;
  flex-wrap: wrap;
}

.cards span {
  font-size: 12px;
  padding: 3px 10px;
  border-radius: 10px;
  background: var(--pill-bg);
  color: var(--accent);
  border: 1px solid var(--pill-line);
}

.bubCol {
  max-width: min(84%, 520px);
}

.bubCol .bub {
  max-width: 100%;
}

.heroBody {
  display: flex;
  align-items: center;
  gap: 14px;
}

.heroMain {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.heroCards {
  flex: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  max-width: 120px;
}

.heroFan {
  position: relative;
  display: flex;
  padding: 2px 0;
}

.heroCard {
  line-height: 0;
}

.heroCard img {
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 180 / 314;
  object-fit: contain;
}

.heroCardFallback {
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 180 / 314;
  font-size: 14px;
  line-height: 1;
  color: var(--muted);
  background: var(--surface);
  border: 1px solid var(--border, currentColor);
  border-radius: 6px;
}

.heroFanItem + .heroFanItem {
  margin-left: -26px;
}

.heroCardName {
  font-size: 11.5px;
  line-height: 1.25;
  color: var(--muted);
  text-align: center;
}

.busyNote {
  align-self: stretch;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 8px 0;
  padding: 14px 16px;
  border: 1px solid var(--pill-line);
  border-radius: 18px;
  background: radial-gradient(120% 140% at 0 0, var(--glow), transparent 70%), var(--surface);
  color: var(--text);
}

.busyNote p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
}

.busyIcon {
  flex: none;
  color: var(--accent);
  font-size: 18px;
  line-height: 1.4;
  animation: busyTwinkle 2.6s ease-in-out infinite;
}

@keyframes busyTwinkle {
  50% {
    opacity: 0.45;
    transform: scale(0.88);
  }
}

@media (prefers-reduced-motion: reduce) {
  .busyIcon {
    animation: none;
  }
}
